import { render, staticRenderFns } from "./mail-template.vue?vue&type=template&id=4e2a6877&scoped=true&"
import script from "./mail-template.vue?vue&type=script&lang=js&"
export * from "./mail-template.vue?vue&type=script&lang=js&"
import style0 from "./mail-template.vue?vue&type=style&index=0&id=4e2a6877&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2a6877",
  null
  
)

export default component.exports